export default __webpack_public_path__ + "ae2ad31c1236fe65112020a3315f2c1b.png";